import * as React from 'react';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as PublicationActionCreators from "../../../actions/publications.actions";
import Select from "react-select";
import "react-select/dist/react-select.css";

export interface IPublicationProps {
    publication: CreDtos.Publication;
    focus: CreDtos.Focus[];
    states: CreDtos.State[];
    publicationTypes: CreDtos.PublicationType[];
    people: CreDtos.People[];
    cancel: Function;
    upsert: Function;
    isSaving: boolean;
}

interface IPublicationState {
    publication: CreDtos.Publication;
    focus: any[];
    states: any[];
    people: any[];
}

class Publication extends React.Component<IPublicationProps, IPublicationState> {
    constructor(props: IPublicationProps) {
        super(props);
        this.state = {
            publication: new CreDtos.Publication(),
            focus: [],
            states: [],
            people: []
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.onUpdateStateFromProps();
    }

    componentDidUpdate(prevProps) {
        if (this.state.publication.id != this.props.publication.id) {
            this.onUpdateStateFromProps();
        }
    }

    onUpdateStateFromProps() {
        let focus = [];

        if (this.props.publication.publicationFocus) {
            focus = this.props.publication.publicationFocus.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.focus.focusName,
                    value: item.focusId
                };
            });
        }

        let states = [];
        if (this.props.publication.publicationState) {
            states = this.props.publication.publicationState.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.state.stateName,
                    value: item.stateId
                };
            });
        }

        let people = [];
        if (this.props.publication.publicationPeople) {
            people = this.props.publication.publicationPeople.filter(f => f.enabled).map((item, index) => {
                return {
                    label: item.people.title,
                    value: item.people.id
                };
            });
        }

        let publication = { ...this.props.publication };

        // default type
        if (!publication.type || publication.type == 0) {
            if (this.props.publicationTypes && this.props.publicationTypes.length > 0) {
                publication.type = this.props.publicationTypes[0].id;
            }
        }

        this.setState({ publication, focus, states, people });
    }

    onValueChanged(fieldName: string, value: any) {
        var publication = { ...this.state.publication };
        if (fieldName == "focus") {
            this.setState({ focus: value });
            publication.publicationFocus = value.map((item, index) => {
                let publicationFocus = new CreDtos.PublicationFocus();
                publicationFocus.focus = new CreDtos.Focus();
                publicationFocus.enabled = true;
                publicationFocus.focusId = item.value;
                publicationFocus.focus.id = item.value;
                publicationFocus.focus.focusName = item.label;
                return publicationFocus;
            });
        }
        else if (fieldName == "states") {
            this.setState({ states: value });
            publication.publicationState = value.map((item, index) => {
                let publicationState = new CreDtos.PublicationState();
                publicationState.state = new CreDtos.State();
                publicationState.enabled = true;
                publicationState.stateId = item.value;
                publicationState.state.id = item.value;
                publicationState.state.stateName = item.label;
                return publicationState;
            });
        }
        else if (fieldName == "people") {
            this.setState({ people: value });
            publication.publicationPeople = value.map((item, index) => {
                let publicationPeople = new CreDtos.PublicationPeople();
                publicationPeople.people = new CreDtos.People();
                publicationPeople.enabled = true;
                publicationPeople.publicationId = item.value;
                publicationPeople.peopleId = item.value;
                publicationPeople.people.id = item.value;
                publicationPeople.people.title = item.label;
                return publicationPeople;
            });
        } else {
            publication[fieldName] = value;
        }
        this.setState({ publication })
    }

    onSave() {
        if (!this.state.publication.type || this.state.publication.type == 0) {
            alert('Type is required');
            return;
        }
        this.props.upsert(this.state.publication);
    }

    render() {
        let content;

        if (this.state.publication) {

            let focusOptions = [];
            if (this.props.focus) {
                focusOptions = this.props.focus.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.focusName,
                        value: e.id
                    }
                });
            }

            let stateOptions = [];
            if (this.props.states) {
                stateOptions = this.props.states.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.stateName,
                        value: e.id
                    }
                });
            }

            let peopleOptions = [];
            if (this.props.people) {
                peopleOptions = this.props.people.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.title,
                        value: e.id
                    }
                });
            }

            let publicationTypeOptions = [];
            if (this.props.publicationTypes) {
                publicationTypeOptions = this.props.publicationTypes.filter(f => f.enabled).map((e, key) => {
                    return {
                        label: e.publicationTypeName,
                        value: e.id
                    }
                });
            }


            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Publication</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Title</label>
                                            <input type="text" className="form-control"
                                                placeholder="Title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.title}
                                                onChange={(e) => this.onValueChanged("title", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Extended Title</label>
                                            <input type="text" className="form-control"
                                                placeholder="Extended Title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.titleExt}
                                                onChange={(e) => this.onValueChanged("titleExt", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Anchor</label>
                                            <input type="text" className="form-control"
                                                placeholder="Extended Title..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.anchor}
                                                onChange={(e) => this.onValueChanged("anchor", e.target.value)}
                                                maxLength={200} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 " style={{display: 'none'}}>
                                        <div className="mb-0 form-group">
                                            <label>Anchor</label>
                                            <input type="text" className="form-control"
                                                placeholder="Anchor..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.anchor}
                                                onChange={(e) => this.onValueChanged("anchor", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Summary</label>
                                            <textarea id="textarea"
                                                className="form-control"
                                                placeholder="Summary..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.summary}
                                                onChange={e => this.onValueChanged("summary", e.target.value)}
                                                rows={5}></textarea>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label style={{ color: this.state.publication.type == 0 ? 'red': 'auto'}} >Type</label>
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="Type"
                                                placeholder={"Type..."}
                                                value={this.state.publication.type}
                                                options={publicationTypeOptions}
                                                onChange={value => this.onValueChanged("type", value.value)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <label>Focus</label>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="Filters"
                                                placeholder={"Focus..."}
                                                value={this.state.focus}
                                                options={focusOptions}
                                                onChange={values => this.onValueChanged("focus", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 mt-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.publication.isInternational}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("isInternational", !this.state.publication.isInternational)}
                                            />
                                            Is International
                                        </label>
                                    </div>
                                    {!this.state.publication.isInternational && (
                                        <div className="col-12">
                                            <label>States</label>
                                        </div>)}
                                    {!this.state.publication.isInternational && (
                                        <div className="col-12">
                                            <div className="mb-0 form-group">
                                                <Select
                                                    name="Filters"
                                                    placeholder={"States..."}
                                                    value={this.state.states}
                                                    options={stateOptions}
                                                    onChange={values => this.onValueChanged("states", values)}
                                                    multi={true}
                                                />
                                            </div>
                                        </div>)}
                                    <div className="col-12">
                                        <label>Authors</label>
                                    </div>
                                    <div className="col-12">
                                        <div className="mb-0 form-group">
                                            <Select
                                                name="People"
                                                placeholder={"Authors..."}
                                                value={this.state.people}
                                                options={peopleOptions}
                                                onChange={values => this.onValueChanged("people", values)}
                                                multi={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Published By</label>
                                            <input type="text" className="form-control"
                                                placeholder="Punblished By..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.publishedby}
                                                onChange={(e) => this.onValueChanged("publishedby", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Link</label>
                                            <input type="text" className="form-control"
                                                placeholder="https://www..."
                                                disabled={this.props.isSaving}
                                                value={this.state.publication.link}
                                                onChange={(e) => this.onValueChanged("link", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label >Year</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder={"Year..."}
                                                value={this.state.publication.year}
                                                onChange={e => this.onValueChanged("year", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.publication.isResource}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("isResource", !this.state.publication.isResource)}
                                            />
                                            Is Resource
                                        </label>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>Sort</label>
                                            <input type="text"
                                                className="form-control"
                                                disabled={this.props.isSaving}
                                                placeholder={"Sort order..."}
                                                value={this.state.publication.sortOrder}
                                                onChange={e => this.onValueChanged("sortOrder", e.target.value)}
                                                maxLength={255} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <label>
                                            <input type="checkbox"
                                                checked={this.state.publication.enabled}
                                                disabled={this.props.isSaving}
                                                onClick={() => this.onValueChanged("enabled", !this.state.publication.enabled)}
                                            />
                                            Enabled
                                        </label>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.cancel()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            );
        }

        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        publication: state.publications.publication,
        focus: state.publications.focus,
        states: state.publications.states,
        publicationTypes: state.publications.publicationTypes,
        people: state.publications.people,
        isSaving: state.publications.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            cancel: PublicationActionCreators.publicationCancel,
            upsert: PublicationActionCreators.publicationUpsertRequest
        },
        dispatch
    );
};


const PublicationContainer = connect(mapStateToProps, mapDispatchToProps)(
    Publication
);

export default PublicationContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/Publications/Publication.tsx